import {Avatar} from '../../../shared/components/avatar';
import {firstNameOf} from '../../../shared/utils/displayName';

export const WaitingRoom = ({
    title,
    name,
    photoUrl,
}: {
    title: string;
    name: string;
    photoUrl: string | null;
}) => (
    <main className="ph-page">
        <div className="ph-stack ph-center ph-fill">
            <p className="ph-tag">{title}</p>
            <Avatar src={photoUrl ?? undefined} name={name} size={72} />
            <h1 className="ph-title">Hi {firstNameOf(name)}!</h1>
            <span className="ph-pulse" aria-hidden="true" />
            <p className="ph-muted">
                Voting starts soon.
                <br />
                Keep this page open.
            </p>
        </div>
    </main>
);
